import i18n from "~/i18n";

export const isSupportedLanguage = (lng: string): boolean => {
  return lng === "ja";
};

export const loadAndApplyLanguage = async (lng: string): Promise<void> => {
  if (!isSupportedLanguage(lng)) return;
  await bootstrapLanguage();
};

export const bootstrapLanguage = async (): Promise<void> => {
  if (!i18n.hasResourceBundle("ja", "translation")) {
    const mod = await import("~/locales/ja.json");
    i18n.addResourceBundle("ja", "translation", mod.default);
  }
  await i18n.changeLanguage("ja");
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("dir", "ltr");
    document.documentElement.setAttribute("lang", "ja");
  }
};
